import { Typography } from '@mui/material';
import { size } from 'lodash';
import React from 'react';

import { useCasesParams } from 'utils/useCasesParams';
import { useMultiplexActionSelection } from './Actions/Multiplex/useMultiplexActionSelection';

export const MultiplexSelectionSummary = () => {
  const { casesParams } = useCasesParams();

  const hasExplicitCaseSelection = size(casesParams.caseIdsToInclude) > 0 || size(casesParams.caseIdsToExclude) > 0;
  const hasExplicitSlideSelection = size(casesParams.slideIdsToInclude) > 0 || size(casesParams.slideIdsToExclude) > 0;
  const shouldResolveSelection = !casesParams.slidesMode && hasExplicitCaseSelection && !hasExplicitSlideSelection;

  const { blockingMessage, hasAmbiguousCases, hasResolvedMultiplexSlides, isLoadingSelection } =
    useMultiplexActionSelection(casesParams, {
      enabled: shouldResolveSelection,
    });

  const shouldShowBlockingSummary =
    Boolean(blockingMessage) && (Boolean(hasResolvedMultiplexSlides) || Boolean(hasAmbiguousCases));

  if (!shouldResolveSelection) {
    return null;
  }

  if (isLoadingSelection) {
    return (
      <Typography
        variant="caption"
        color="text.secondary"
        data-cy="multiplex-selection-summary"
        sx={{ display: 'block', lineHeight: 1.3 }}
      >
        Multiplex actions run on slides. Checking the selected cases.
      </Typography>
    );
  }

  if (!shouldShowBlockingSummary) {
    return null;
  }

  return (
    <Typography
      variant="caption"
      data-cy="multiplex-selection-summary"
      sx={{
        display: 'block',
        lineHeight: 1.3,
        color: 'warning.main',
      }}
    >
      Multiplex actions run on slides. {blockingMessage}
    </Typography>
  );
};
